import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { catchError } from "rxjs/operators";
import { EMPTY } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { CustomerFacade } from "../../domain/+state/customer.facade";
import { ConfirmNewPhoneNumberResponse } from "../../domain/models/customer.model";
import { SsoAccountFacade } from "../../../sso-account/domain/+state/sso-account.facade";
import { SsoAccountData } from "../../../sso-account/domain/models/sso-account.model";
import { MessageService } from "../../../../message/message.service";
import { HiddenPhonePipe } from "../../../../../lib/ui/pipes/hidden-phone.pipe";
import { SimpleDialogComponent } from "../../../../../lib/ui/dialog/simple-dialog/simple-dialog.component";
import { SimpleDialogData } from "../../../../../lib/ui/dialog/simple-dialog/simple-dialog.model";
import { ButtonColor, CommonActionKey } from "../../../../../lib/ui/dialog/base-dialog/base-dialog.model";

@UntilDestroy()
@Component({
  selector: "ifc-phone-number-confirmation-reminder",
  templateUrl: "./phone-number-confirmation-reminder.component.html",
  styleUrls: ["./phone-number-confirmation-reminder.component.scss"],
  standalone: false,
})
export class PhoneNumberConfirmationReminderComponent implements OnInit {
  oldPhoneNumber: number;
  newPhoneNumber: number;
  waitingForConfirmation: boolean;
  customerId: number;

  constructor(
    private customerFacade: CustomerFacade,
    private messageService: MessageService,
    private dialog: MatDialog,
    private hiddenPhonePipe: HiddenPhonePipe,
    private ssoAccountFacade: SsoAccountFacade
  ) {}

  ngOnInit(): void {
    this.ssoAccountFacade
      .getCurrentSsoAccount$()
      .pipe(untilDestroyed(this))
      .subscribe((res: SsoAccountData) => {
        this.oldPhoneNumber = res?.mobilePhone;
        this.newPhoneNumber = res?.mobilePhoneUnverified;
        this.waitingForConfirmation = res?.waitingForPhoneConfirmation;
        this.customerId = res?.id;
      });
  }

  confirmPhoneNumber(): void {
    this.customerFacade
      .confirmMobilePhoneNumberChange({
        customerId: this.customerId,
        oldPhoneNumber: this.oldPhoneNumber,
      })
      .pipe(catchError((error) => this.submitError(error)))
      .subscribe((data) => this.submitSuccess(data));
  }

  discardPhoneNumber(): void {
    const data: SimpleDialogData = {
      body: `Discard new phone number ${this.hiddenPhonePipe.transform(
        this.newPhoneNumber
      )}.`,
      title: "Confirm?",
      actions: [
        { label: "CANCEL", buttonColor: ButtonColor.Default, actionKey: CommonActionKey.Cancel },
        { label: "CONFIRM", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Confirm },
      ],
    };
    SimpleDialogComponent.show(this.dialog, data).subscribe((actionKey: string) => {
      if (actionKey === CommonActionKey.Confirm) {
        this.customerFacade
          .discardMobilePhoneNumberChange(this.customerId)
          .pipe(catchError((error) => this.submitError(error)))
          .subscribe(() => this.customerFacade.redirectToDashboard());
      }
    });
  }

  submitSuccess(data: ConfirmNewPhoneNumberResponse): void {
    if (!data?.hasError) {
      this.customerFacade.redirectToDashboard();
    }
  }

  submitError(error: any) {
    this.messageService.error(error);
    return EMPTY;
  }
}
